export default __webpack_public_path__ + "static/media/cart.f9b072af.svg";